/**
 * Separator between items of an entity's meta line ("Start here · 11 hours ago", "Song · 12 days ago").
 * Non-breaking spaces: meta lines are often flex rows, where a flex item's leading and trailing ordinary
 * spaces are trimmed ("Start here·11 hours ago").
 */
export const metaSeparator = ' · '
